/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '@reducers/rootReducer';

import { initWizardOrderTemplateState } from './constants';
import { IWizardOrderTemplateReducer } from './reducer';
import { IWizardOrderTemplateValidation } from './types';

export const makeSelectWizardOrderTemplateState = (state: IRootReducer): IWizardOrderTemplateReducer =>
    state.wizardOrderTemplate || initWizardOrderTemplateState;

export const makeSelectWizardOrderTemplateValidation = (): OutputSelector<
    IRootReducer,
    IWizardOrderTemplateValidation,
    (state: IWizardOrderTemplateReducer) => IWizardOrderTemplateValidation
> => createSelector(makeSelectWizardOrderTemplateState, (state) => state.validation);
